export class StaffGrade {
  StaffGrade;
  EDesc;
  CDesc;
  ModifyBy;
  constructor() {
    this.StaffGrade = "";
    this.EDesc = "";
    this.CDesc = "";
    this.ModifyBy = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/StaffGrade.js